import React from 'react';
import ThemeToggle from '../components/ThemeToggle';
import GlobalSearch from './GlobalSearch';

export default function TopBar() {
  return (
    <header className="h-topbar shrink-0 flex items-center gap-3 px-5 bg-sheet border-b border-rule">
      <GlobalSearch />
      <div className="flex-1" />
      <ThemeToggle />
    </header>
  );
}
